module.exports = __webpack_public_path__ + "static/media/sbd.707f0f6c.svg";